import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import { toast } from "react-toastify";
import "./kycDetail.scss";

function KYC_Detail() {
  const location = useLocation();
  const user_id = location?.state?.user_id;

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = ` KYC | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const [kycDetails, setKycDetails] = useState({});

  const fetchKYCDetails = async () => {
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/get_member_details?user_id=${user_id}`;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      console.log(data);

      setKycDetails(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const [dropdown, setDropdown] = useState(false);
  const handleDropdown = () => {
    setDropdown(!dropdown);
  };
  const handleStatus = async (kyc_Detail, e) => {
    const accessToken = window.localStorage.getItem("access_token");

    const updateUser = {
      country_code: kyc_Detail.member_data.country_code,
      phone_no: kyc_Detail.member_data.phone_no,
      status: e,
    };

    const url = `https://ballersapi.ballerslife.co/api/v1/admin/update_user_application`;
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(updateUser),
      });
      const data = await response.json();
      if (response.status === 200) {
        toast.success(data);
        fetchKYCDetails();
        handleDropdown();
      } else if (response.status === 403) {
        window.localStorage.removeItem("access_token");
        window.localStorage.removeItem("flag");
        navigate("/adminlogin");
        window.location.reload();
        setLoading(false);
      } else {
        toast.error(data);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(" An error occurred, please try again later.");
    }
  };

  const [dropdownKYCStatus, setDropdownKYCStatus] = useState(false);
  const handleKYCDropdown = () => {
    setDropdownKYCStatus(!dropdownKYCStatus);
  };

  const updateKYCStatus = async (kyc_Detail, e) => {
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/update_member_kyc_status?user_id=${kycDetails.member_data.user_id}&kyc_status=${e}`;
    console.log(url);
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      console.log(data);
      if (response.status === 200) {
        toast.success(data);
      } else {
        toast.error(data.detail);
      }
      fetchKYCDetails();
      setDropdownKYCStatus(false);
    } catch (error) {
      console.log(error);
    }
  };

  const [addressProofStatus, setAddressProofStatus] = useState(false);
  const handleAddressProofStatus = () => {
    setAddressProofStatus(!addressProofStatus);
  };
  const updateAddressProofStatus = async (kyc_Detail, e) => {
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/update_doc_status?user_id=${kycDetails.member_data.user_id}&address_proof_status=${e}`;
    console.log(url);
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        toast.success(data);
      } else {
        toast.error(data.detail);
      }
      fetchKYCDetails();
      setAddressProofStatus(false);
    } catch (error) {
      console.log(error);
    }
  };

  const [passportStatus, setPassportStatus] = useState(false);
  const handlePassportStatus = () => {
    setPassportStatus(!passportStatus);
  };
  const updatePassportStatus = async (kyc_Detail, e) => {
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/update_doc_status?user_id=${kycDetails.member_data.user_id}&passport_details_status=${e}`;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        toast.success(data);
      } else {
        toast.error(data.detail);
      }
      fetchKYCDetails();
      setPassportStatus(false);
    } catch (error) {
      console.log(error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const sendApprovalMail = async () => {
    const encodedCountryCode = encodeURIComponent(
      kycDetails.member_data.country_code
    );
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/send_approval_mail?country_code=${encodedCountryCode}&phone_no=${kycDetails.member_data.phone_no}`;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();

      if (data === null) {
        toast.error("Please try after some time");
      } else if (response.status === 200) {
        toast.success(data.status);
      } else {
        toast.error(data.detail);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const sendKycRemMail = async () => {
    const encodedCountryCode = encodeURIComponent(
      kycDetails.member_data.country_code
    );

    const url = `https://ballersapi.ballerslife.co/api/v1/admin/mail/send_KYC_reminder_mail?country_code=${encodedCountryCode}&phone_no=${kycDetails.member_data.phone_no} `;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      console.log(data);
      if (response.status === 200) {
        toast.success(data.status);
      } else {
        toast.error(data.detail);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchKYCDetails();
  }, [user_id]);

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        <div className="user">
          <div className="svgMain" onClick={handleSvg}>
            {hideSvg ? (
              <div className="closeSvg"></div>
            ) : (
              <div className="hamburgerSvg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#0F0223"
                  stroke="#eee2e2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-menu"
                >
                  <line x1="4" x2="20" y1="12" y2="12" />
                  <line x1="4" x2="20" y1="6" y2="6" />
                  <line x1="4" x2="20" y1="18" y2="18" />
                </svg>
              </div>
            )}
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="memberKycMain">
              <div className="goBackSvg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#FFBF00"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-chevron-left"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </div>
              <div className="memberKycBody">
                <p className="headerKyc">Member Details</p>
                <div className="sendApprovalMail">
                  <div className="memberKycCont">
                    {kycDetails.member_data.user_name && (
                      <>
                        <p className="kycDetailFont">Name :</p>
                        <p className="kycDetailFont2">
                          {kycDetails.member_data.user_name}
                        </p>
                      </>
                    )}
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="23"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ebb103"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-mail"
                    cursor="pointer"
                    onClick={() => {
                      sendApprovalMail();
                    }}
                  >
                    <rect width="20" height="16" x="2" y="4" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                </div>

                {kycDetails.member_data.created_at && (
                  <div className="memberKycCont">
                    <p className="kycDetailFont">Application :</p>
                    <p className="kycDetailFont2">
                      {formatDate(kycDetails.member_data.created_at)}
                    </p>
                  </div>
                )}

                {kycDetails.member_data.status && (
                  <div className="memberKycCont">
                    <p className="kycDetailFont">Status :</p>
                    <p className="kycDetailFont2">
                      <div className="statusDropdown">
                        {kycDetails.member_data.status}
                        <p onClick={() => handleDropdown()}>
                          {dropdown ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#f5f5f5"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-chevron-up"
                            >
                              <path d="m18 15-6-6-6 6" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#f5f5f5"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-chevron-down"
                            >
                              <path d="m6 9 6 6 6-6" />
                            </svg>
                          )}
                        </p>
                        {dropdown && (
                          <div
                            className="dropDownKycDetail"
                            onClick={(event) =>
                              handleStatus(kycDetails, event.target.textContent)
                            }
                          >
                            <div className="dropdownCont">
                              <p>approved</p>
                            </div>
                            <div className="dropdownCont">
                              <p>under_review</p>
                            </div>
                            <div className="dropdownCont">
                              <p>declined</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </p>
                  </div>
                )}

                {kycDetails.member_data.phone_no && (
                  <div className="memberKycCont">
                    <p className="kycDetailFont">Phone No :</p>
                    <p className="kycDetailFont2">
                      {kycDetails.member_data.phone_no}
                    </p>
                  </div>
                )}

                {kycDetails.member_data.email_id && (
                  <div className="memberKycCont">
                    <p className="kycDetailFont">Email :</p>
                    <p className="kycDetailFont2">
                      {kycDetails.member_data.email_id}
                    </p>
                  </div>
                )}

                {kycDetails.member_data.social_media_handle && (
                  <div className="memberKycCont">
                    <p className="kycDetailFont">Social Media Profile :</p>
                    <p className="kycDetailFont2">
                      <a
                        href={kycDetails.member_data.social_media_handle}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {kycDetails.member_data.social_media_handle}
                      </a>
                    </p>
                  </div>
                )}

                {kycDetails.member_data.investment_amount_capacity && (
                  <div className="memberKycCont">
                    <p className="kycDetailFont">Investment Capacity :</p>
                    <p className="kycDetailFont2">
                      {kycDetails.member_data.investment_amount_capacity}
                    </p>
                  </div>
                )}

                {kycDetails.member_data.interested_sports &&
                  kycDetails.member_data.interested_sports.length > 0 && (
                    <div className="memberKycCont">
                      <p className="kycDetailFont">Interested Sports :</p>
                      <p className="kycDetailFont2">
                        {kycDetails.member_data.interested_sports.join(" , ")}
                      </p>
                    </div>
                  )}

                {kycDetails.member_data.kyc_status && (
                  <div className="memberKycCont">
                    <p className="kycDetailFont">KYC Status :</p>
                    <p className="kycDetailFont2">
                      <div className="statusDropdown">
                        {kycDetails.member_data.kyc_status}
                        <p onClick={() => handleKYCDropdown()}>
                          {dropdownKYCStatus ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#f5f5f5"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-chevron-up"
                              style={{ cursor: "pointer" }}
                            >
                              <path d="m18 15-6-6-6 6" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#f5f5f5"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-chevron-down"
                              style={{ cursor: "pointer" }}
                            >
                              <path d="m6 9 6 6 6-6" />
                            </svg>
                          )}
                        </p>
                        {dropdownKYCStatus && (
                          <div
                            className="dropDownKycDetail"
                            onClick={(event) =>
                              updateKYCStatus(
                                kycDetails,
                                event.target.textContent
                              )
                            }
                          >
                            <div className="dropdownCont">
                              <p>pending</p>
                            </div>
                            <div className="dropdownCont">
                              <p>verified</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </p>
                  </div>
                )}
              </div>
            </div>
            {kycDetails.kyc_details === "KYC not done" ? (
              <div className="memberKycMain">
                <div className="memberKycBodySec">
                  <div className="headerKyc">
                    <p>KYC Details</p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23"
                      height="23"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ebb103"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-mail"
                      cursor={"pointer"}
                      onClick={() => {
                        sendKycRemMail();
                      }}
                      className="wrapMail"
                    >
                      <rect width="20" height="16" x="2" y="4" rx="2" />
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                    </svg>
                  </div>
                  <div className="memberKycCont">
                    <p className="kycDetailFont">KYC not done.</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="memberKycMain">
                <div className="memberKycBodySec">
                  <div className="headerKyc">
                    <p>KYC Details</p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23"
                      height="23"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ebb103"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-mail"
                      cursor={"pointer"}
                      onClick={() => {
                        sendKycRemMail();
                      }}
                      className="wrapMail"
                    >
                      <rect width="20" height="16" x="2" y="4" rx="2" />
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                    </svg>
                  </div>
                  <div className="memberKycCont">
                    <p className="kycDetailFont">Citizenship :</p>
                    <p className="kycDetailFont2">
                      {kycDetails.kyc_details.citizenship}
                    </p>
                  </div>
                  <div id="passportDetailAd">
                    <div className="memberKycContBott">
                      <p className="kycDetailFont">Address Proof Status :</p>
                      <p className="kycDetailFont2">
                        <div className="statusDropdown">
                          <>{kycDetails.kyc_details.address_proof_status}</>
                          <p
                            onClick={() => {
                              handleAddressProofStatus();
                            }}
                          >
                            {addressProofStatus ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#f5f5f5"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-chevron-up"
                                style={{ cursor: "pointer" }}
                              >
                                <path d="m18 15-6-6-6 6" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#f5f5f5"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-chevron-down"
                                style={{ cursor: "pointer" }}
                              >
                                <path d="m6 9 6 6 6-6" />
                              </svg>
                            )}
                          </p>
                          {addressProofStatus ? (
                            <div
                              className="dropDownKycDetail"
                              onClick={(event) => {
                                updateAddressProofStatus(
                                  kycDetails,
                                  event.target.textContent
                                );
                              }}
                            >
                              <div className="dropdownCont ">
                                <p>verified</p>
                              </div>
                              <div className="dropdownCont ">
                                <p>pending</p>
                              </div>
                              <div className="dropdownCont ">
                                <p>declined</p>
                              </div>
                              <div className="dropdownCont ">
                                <p>under_review</p>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </p>
                    </div>
                    <div className="memberKycContBott">
                      <p className="kycDetailFont">Address Proof :</p>
                      <p className="kycDetailFont2">
                        <a
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                          }}
                          target="_blank"
                          href={kycDetails.kyc_details.address_proof}
                        >
                          {/* {kycDetails.kyc_details.address_proof.replace(
                            /^https:\/\/s3\.ap-south-1\.amazonaws\.com\/www\.cratermedia\//,
                            ""
                          )} */}
                          {kycDetails.kyc_details.address_proof.substring(
                            kycDetails.kyc_details.address_proof.lastIndexOf(
                              "/"
                            ) + 1
                          )}
                        </a>
                      </p>
                    </div>
                  </div>
                  <div id="addressDetailAd">
                    <div className="memberKycContBott">
                      <p className="kycDetailFont">Passport Status :</p>
                      <p className="kycDetailFont2">
                        <div className="statusDropdown">
                          <> {kycDetails.kyc_details.passport_details_status}</>
                          <p
                            onClick={() => {
                              handlePassportStatus();
                            }}
                          >
                            {passportStatus ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#f5f5f5"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-chevron-up"
                                style={{ cursor: "pointer" }}
                              >
                                <path d="m18 15-6-6-6 6" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#f5f5f5"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-chevron-down"
                                style={{ cursor: "pointer" }}
                              >
                                <path d="m6 9 6 6 6-6" />
                              </svg>
                            )}
                          </p>
                          {passportStatus ? (
                            <div
                              className="dropDownKycDetail"
                              onClick={(event) => {
                                updatePassportStatus(
                                  kycDetails,
                                  event.target.textContent
                                );
                              }}
                            >
                              <div className="dropdownCont ">
                                <p>verified</p>
                              </div>
                              <div className="dropdownCont ">
                                <p>pending</p>
                              </div>
                              <div className="dropdownCont ">
                                <p>declined</p>
                              </div>
                              <div className="dropdownCont ">
                                <p>under_review</p>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </p>
                    </div>
                    <div className="memberKycContBott">
                      <p className="kycDetailFont">Passport Details :</p>
                      <p className="kycDetailFont2">
                        <a
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                          }}
                          target="_blank"
                          href={kycDetails.kyc_details.passport_details}
                        >
                          {/* {kycDetails.kyc_details.passport_details.replace(
                            /^https:\/\/s3\.ap-south-1\.amazonaws\.com\/www\.cratermedia\//,
                            ""
                          )} */}
                          {kycDetails.kyc_details.passport_details.substring(
                            kycDetails.kyc_details.passport_details.lastIndexOf(
                              "/"
                            ) + 1
                          )}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default KYC_Detail;
